import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}

export function isNumber(value: any): value is number {
  return !isNaN(toInteger(value));
}

export function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return "";
  }
}

@Injectable()
export class DateParserFormatter extends NgbDateParserFormatter {
  parse(value: string) {
    if (value) {
      const dateParts = value.trim().split("/");
      if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        return {
          year: toInteger(dateParts[2]),
          month: toInteger(dateParts[0]),
          day: toInteger(dateParts[1]),
        };
      }
    }
    return null;
  }

  format(date: NgbDateStruct) {
    if (!date) {
      return "";
    }
    return `${isNumber(date.month) ? padNumber(date.month) : ""}/${isNumber(date.day) ? padNumber(date.day) : ""}/${date.year}`;
  }
}
